import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, message, Button } from 'hljd'
import store from '../store'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import { MARKETING_CENTER_PATH_A } from '@constant'

const Item = Form.Item
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 }
}

@observer
export default class extends Component {
  state = {
    name: '',
    id: '',
    banknum: '',
    phone: ''
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  submit = () => {
    let regCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    let regPhone = /^0?1[3|4|5|8|7][0-9]\d{8}$/

    if (this.state.name == '') {
      message.error('请填写真实姓名')
    } else if (regCard.test(this.state.id) === false) {
      message.error('身份证格式不对')
    } else if (this.state.banknum == '') {
      message.error('请填写银行账号')
    } else if (
      this.state.phone == '' ||
      this.state.phone.length != 11 ||
      !regPhone.test(this.state.phone)
    ) {
      message.error('手机格式不对')
    } else {
      const { payBond } = store
      let params = {
        agent: 'llpay',
        kind: '3',
        return_url: MARKETING_CENTER_PATH_A,
        user_bankcard: this.state.banknum,
        user_idcard: this.state.id,
        user_name: this.state.name,
        user_phone: this.state.phone
      }
      payBond(params, 'card')
    }
  }

  render() {
    return (
      <div className={Styles.card}>
        <Form>
          <Item {...layout} required label="真实姓名">
            <Input
              name="name"
              placeholder="请输入本人真实姓名"
              onChange={this.onChange}
            />
          </Item>
          <Item {...layout} required label="身份证号">
            <Input
              name="id"
              placeholder="请输入身份证号"
              onChange={this.onChange}
            />
          </Item>
          <Item {...layout} required label="银行账号">
            <Input
              name="banknum"
              placeholder="请输入银行卡号"
              onChange={this.onChange}
            />
          </Item>
          <Item {...layout} required label="预留银行手机号">
            <Input
              name="phone"
              placeholder="请输入手机号"
              onChange={this.onChange}
            />
          </Item>
        </Form>

        <div className={Styles.btnBox}>
          <Button onClick={this.submit} type="primary">
            立即缴纳
          </Button>
        </div>
      </div>
    )
  }
}
